const MAX_DEPTH = 50;

const traverseObject = (obj, excludedKeys, transformerFn) => {
  const seen = new WeakSet();

  const walk = (node, depth) => {
    if (!node || typeof node !== "object") return node;
    if (depth > MAX_DEPTH) return node;
    if (seen.has(node)) return {};
    seen.add(node);

    let result;
    if (Array.isArray(node)) {
      result = node.map(item => walk(item, depth + 1));
    } else {
      result = Object.keys(node).reduce((res, key) => {
        if (!excludedKeys.includes(key)) {
          res[transformerFn(key)] = walk(node[key], depth + 1);
        } else {
          res[key] = node[key];
        }

        return res;
      }, {});
    }

    seen.delete(node);
    return result;
  };

  return walk(obj, 0);
};

export const camelize = str =>
  /[-_]/g.test(str) ? str.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase()) : str;

/**
 * Converts all object keys from snake_case or kebab-case to camelCase recursively
 * @template T
 * @param {T} obj - The object to transform
 * @param {string[]} [excludedKeys=[]] - Keys to exclude from transformation
 * @returns {T} A new object with all keys transformed to camelCase
 */
export const objNamesToCamelCase = (obj, excludedKeys = []) =>
  traverseObject(obj, excludedKeys, camelize);

export const simpleSnakeCase = str =>
  str
    .replace(/([a-z\d])([A-Z])/g, "$1_$2")
    .replace(/\W+/g, "_")
    .toLowerCase()
    .replace(/^_|_$/g, "");

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/**
 * Converts all object keys from camelCase to snake_case recursively
 * @template T
 * @param {T} obj - The object to transform
 * @param {string[]} [excludedKeys=[]] - Keys to exclude from transformation
 * @returns {T} A new object with all keys transformed to snake_case
 */
export const objNamesToSnakeCase = (obj, excludedKeys = []) =>
  traverseObject(obj, excludedKeys, camelToSnakeCase);

export default {};
